// extracted by mini-css-extract-plugin
export default {"buttonBox":"button_buttonBox__VZn0c","btn":"button_btn__i2CrJ"};